/* eslint-disable jsx-a11y/anchor-is-valid */
import { Bot, MessagesSquare } from "lucide-react";
import { useEffect, useMemo, useState } from "react";
import { Collapse } from "react-bootstrap";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { Routes } from "../../AppRoutes";
import { Icon } from "../../components";
import { Header } from "../../components/header";
import { CreateNotification } from "../../components/notifier";
import { useUser } from "../../hook";
import CountPreview from "../landing2/CountPreview";
import { PERMISSION_LOOKUP_VERSION } from "../../constants/version";

import "antd/dist/antd.css";

const MenuWithChildren = (props: any) => {
  const { onClick, show, menu, childrens, showSTT } = props;

  const handleNotify = () => {
    CreateNotification({
      title: "Thông báo",
      body: `Tính năng đang được thực hiện, sẽ triển khai cho anh/chị trong thời gian sớm nhất. Xin cảm ơn !`,
      icon: "/icons/warning.png",
    });
  };

  return (
    <div className="content__menu-active">
      <a className="tittle__menu" onClick={onClick} role="presentation">
        {menu.icon}
        {menu.title}
      </a>
      <Collapse in={show}>
        <div className="pl-2 ml-1">
          {childrens.map((item: any, index: number) =>
            item?.path ? (
              <NavLink style={{ display: "block", width: "100%" }} to={item?.path} key={index}>
                {showSTT ? `${index + 1}. ` : ``}
                {item?.title}
              </NavLink>
            ) : (
              <div
                style={{
                  display: "block",
                  width: "100%",
                  fontWeight: 500,
                  opacity: 0.7,
                }}
                role="button"
                onClick={handleNotify}
                key={index}
              >
                {item?.title}
              </div>
            ),
          )}
        </div>
      </Collapse>
    </div>
  );
};

//Mục menu naviagtion Đào Tạo
// const TrainingMenu = () => {
//   const [show, set] = useState(true);
//   return (
//     <MenuWithChildren
//       menu={Routes.procedureTraining}
//       childrens={[Routes.procedureTrainingPlan, Routes.procedureTrainingCourse, Routes.procedureTrainingStudent]}
//       show={show}
//       onClick={() => set(!show)}
//     />
//   );
// };

// Planing page
//Văn phòng Điện tử
const eOfficeProcess = {
  menu: {
    isAdmin: false,
    title: "VĂN PHÒNG ĐIỆN TỬ",
    path: "/procedure",
    icon: <Icon.Procedure />,
  },
  children: [
    {
      isAdmin: false,
      title: "1. CÔNG NGHỆ THÔNG TIN",
      path: "/procedure/account-delete-granted",
      parentId: "procedure",
    },
    {
      isAdmin: false,
      title: "2. VĂN PHÒNG CÔNG TY",
      path: "/procedure/business-tickets",
      parentId: "procedure",
    },
    {
      isAdmin: false,
      title: "3. TỔ CHỨC NHÂN LỰC",
      path: "/procedure/absence-letter",
      parentId: "procedure",
    },
    {
      isAdmin: false,
      title: "4. CHI NHÁNH NỘI BÀI",
      path: "/procedure/absence-letter-nba",
      parentId: "procedure",
    },
    {
      isAdmin: false,
      title: "5. CHI NHÁNH ĐÀ NẴNG",
      path: "/procedure/absence-letter-dad",
      parentId: "procedure",
    },
    // {
    //   isAdmin: false,
    //   title: "4. KẾ HOẠCH ĐẦU TƯ",
    //   path: "/procedure/recall-tool",
    //   parentId: "procedure",
    // },
    {
      isAdmin: true,
      title: "📊 THỐNG KÊ",
      path: "/procedure/statistics",
      parentId: "procedure",
    },
    {
      isAdmin: true,
      title: "⚙️ CẤU HÌNH",
      path: "/procedure/config",
      parentId: "procedure",
    },
  ],
};

//UI navigate VPĐT
const EOfficeProcess = () => {
  const { pathname } = useLocation();
  const [show, set] = useState(!pathname.includes("document"));

  return (
    <MenuWithChildren
      menu={eOfficeProcess.menu}
      childrens={eOfficeProcess.children}
      show={show}
      onClick={() => {
        set(!show);
      }}
    />
  );
};

//UI navigate QLTL
const ViagsDocument = () => {
  const [show, set] = useState(true);
  const history = useHistory();
  const { userAdmin } = useUser();

  const viagsDocument = {
    menu: {
      isAdmin: false,
      title: "HỆ THỐNG TÀI LIỆU VIAGS",
      path: "/landing-document",
      icon: <Icon.Compose />,
    },
    children: [
      {
        isAdmin: true,
        title: "1. QUẢN LÝ TÀI LIỆU",
        path: userAdmin?.id ? "/document" : "/document?status=publish",
        parentId: "document",
      },
      {
        isAdmin: false,
        title: "2. TÀI LIỆU BAN HÀNH",
        path: "/document?status=publish",
        parentId: "document",
      },
      {
        isAdmin: true,
        title: "3. THỐNG KÊ",
        path: "/statistic",
        parentId: "document",
      },
      {
        isAdmin: true,
        title: "4. CẤU HÌNH",
        path: "/setting/document/type",
        parentId: "document",
      },
    ],
  };

  return (
    <MenuWithChildren
      menu={viagsDocument.menu}
      childrens={viagsDocument.children}
      show={show}
      onClick={() => {
        set(!show);
        history.push(Routes.ladingDocument.path);
      }}
    />
  );
};

const ViagsChat = () => {
  const { pathname } = useLocation();
  const [show, setShow] = useState(!pathname.includes("document"));

  const viagsChat = {
    menu: {
      isAdmin: false,
      title: "TRAO ĐỔI THÔNG TIN",
      path: "/chats",
      icon: <Icon.ChatIcon />,
    },
    children: [
      {
        isAdmin: true,
        title: (
          <>
            <MessagesSquare size={16} style={{ marginRight: 5 }} /> CHAT NỘI BỘ (VIAGS CHAT)
          </>
        ),
        path: "/chats",
        parentId: "/chats",
      },
      {
        isAdmin: true,
        title: (
          <>
            <Bot size={16} style={{ marginRight: 5 }} /> VIAGS GPT
          </>
        ),
        path: "/viags-gpt",
        parentId: "/viags-gpt",
      },
    ],
  };

  const handleClick = () => {
    const newShow = !show;
    setShow(newShow);
    localStorage.setItem("bubbleChatHidden", newShow ? "true" : "false");

    // Gửi sự kiện để BubbleChat cập nhật trạng thái
    window.dispatchEvent(new Event("storage"));
  };

  return <MenuWithChildren menu={viagsChat.menu} childrens={viagsChat.children} show={show} onClick={handleClick} />;
};

//Văn phòng E office
const InfoTechnologyProcess = () => {
  const [show, set] = useState(true);

  const menu = useMemo(() => {
    const oldMenuVos = [
      Routes.procedureDeleteUserAccount,
      Routes.procedureProcessEpr,
      Routes.procedureProcessVms,
      Routes.procedureRepairTools,
      Routes.procedureDemandForSupplies,
    ];

    const newMenuVos = [
      Routes.procedureDeleteUserAccount,
      Routes.procedureProcessEpr,
      Routes.permissionLookupManagement,
      Routes.procedurePermissionLookupManagement,
      Routes.accessPermissionLookup,
      Routes.procedureRepairTools,
      Routes.procedureDemandForSupplies,
    ];

    const menu = PERMISSION_LOOKUP_VERSION === 1 ? oldMenuVos : newMenuVos;

    return menu;
  }, []);

  return (
    <MenuWithChildren showSTT menu={Routes.procedureProcess} childrens={menu} show={show} onClick={() => set(!show)} />
  );
};
//Văn phòng công ty
const OfficeProcess = () => {
  const [show, set] = useState(true);
  return (
    <MenuWithChildren
      menu={Routes.procedureOfficeProcess}
      childrens={[
        Routes.procedureCollaborateTicket,
        Routes.securityControlCardIssuance,
        Routes.ProcessSecurityControlCardsToExternalUnits,
        Routes.businessVehicleCardPage,
        Routes.businessVehicleCardPageToExternal,
        Routes.officialVehicleListPage,
        // Routes.meetingRequestPage,
        // Routes.businessCard,
        // Routes.stationaryRequest,
      ]}
      show={show}
      onClick={() => set(!show)}
    />
  );
};
//Kế toán
// const ProcedureAccountingDept = () => {
//   const [show, set] = useState(true);
//   return (
//     <MenuWithChildren
//       menu={Routes.procedureAccounting}
//       childrens={[Routes.procedureAdvanceOffer, Routes.procedureAssetHandover]}
//       show={show}
//       onClick={() => set(!show)}
//     />
//   );
// };

//Phòng kế hoạch đầu tư
// const PlanningDepartment = () => {
//   const [show, set] = useState(true);
//   return (
//     <MenuWithChildren
//       menu={Routes.procedurePlanningDepartment}
//       childrens={[Routes.procedureRecallTool, Routes.procedureExportWarehouse]}
//       show={show}
//       onClick={() => set(!show)}
//     />
//   );
// };

// //Phòng nhân sự
// const RecommendDepartment = () => {
//   const [show, set] = useState(true);
//   return (
//     <MenuWithChildren
//       menu={Routes.procedureRecommendDepartment}
//       childrens={[Routes.procedureWareHouse, Routes.procedureExportHouse]}
//       show={show}
//       onClick={() => set(!show)}
//     />
//   );
// };
//Phòng an toàn
// const SafeDepartment = () => {
//   const [show, set] = useState(true);
//   return (
//     <MenuWithChildren
//       menu={Routes.procedureSafe}
//       childrens={[Routes.documentAccess, Routes.promulgatingEditDoc]}
//       show={show}
//       onClick={() => set(!show)}
//     />
//   );
// };

//Phòng nhân sự
// const ResourcesDepartmentProcess = () => {
//   const [show, set] = useState(true);
//   return (
//     <MenuWithChildren
//       menu={Routes.procedureResourcesDepartmentProcess}
//       childrens={[Routes.procedureApplicationForLeave, Routes.procedurePauseLaborContract, Routes.procedureMove]}
//       show={show}
//       onClick={() => set(!show)}
//     />
//   );
// };

const HumanOrganizationDepartment = () => {
  const [show, set] = useState(true);
  return (
    <MenuWithChildren
      menu={Routes.humanOrganizationDepartment}
      childrens={[
        Routes.absenceLetterPage,
        Routes.absenceNoSalary,
        Routes.absenceSuspendConstract,
        Routes.absenceTerminateConstract,
        Routes.statisticAbsenceLetterPage,
        // Routes.applicationForLeavePage,
        // Routes.accidentInvestigationRecordPage,
        // Routes.employeeConfirmation,
        // Routes.coursePersonChangeFormPage,
        // Routes.personRegisteredCourse,
        // Routes.summaryRegistrationCourses,
        // Routes.monthlyTrainingPlanPage,
        // Routes.mtpsPage,
        // Routes.meetingRoomPage,

        // Routes.totalEmployeesForm,
      ]}
      show={show}
      onClick={() => set(!show)}
      // onClick={() =>
      //   CreateNotification({
      //     title: "Thông báo",
      //     body: "Tính năng đang được thực hiện, sẽ triển khai cho anh/chị trong thời gian sớm nhất. Trân trọng !",
      //     icon: "/icons/warning.png",
      //   })
      // }
    />
  );
};

const ApplicationForLeaveNBA = () => {
  const [show, set] = useState(true);
  return (
    <MenuWithChildren
      menu={Routes.aflNBA}
      childrens={[Routes.absenceLetterNBAPage]}
      show={show}
      onClick={() => set(!show)}
    />
  );
};

const ApplicationForLeaveDAD = () => {
  const [show, set] = useState(true);
  return (
    <MenuWithChildren
      menu={Routes.aflDAD}
      childrens={[
        Routes.absenceLetterDADPage,
        Routes.maternityLeaveDADPage,
        Routes.sickLeaveDADPage,
        Routes.noSalaryLeaveDADPage,
        Routes.suspendContractDADPage,
        Routes.terminationContractDADPage,
      ]}
      show={show}
      onClick={() => set(!show)}
      // onClick={() =>
      //   CreateNotification({
      //     title: "Thông báo",
      //     body: "Tính năng đang được thực hiện, sẽ triển khai cho anh/chị trong thời gian sớm nhất. Trân trọng !",
      //     icon: "/icons/warning.png",
      //   })
      // }
    />
  );
};

export const withProcedureWraper = (Component: any) => (props: any) => {
  const breakpoint = useMediaQuery("(max-width: 1080px)");
  const [closeMenu, setCloseMenu] = useState(breakpoint);

  const handleCloseMenu = () => {
    setCloseMenu(!closeMenu);
  };

  useEffect(() => {
    if (breakpoint) {
      return;
    }

    let timer: NodeJS.Timeout | null = null;

    if (!closeMenu) {
      timer = setTimeout(() => {
        setCloseMenu(true);
      }, 30000);
    }

    return () => {
      timer && clearTimeout(timer);
    };
  }, [breakpoint, closeMenu]);

  return (
    <>
      <Header />
      <div className={closeMenu === false ? "Menu__Navgiator" : "Menu__Navgiator active"}>
        <div
          className="collapse_icons"
          onClick={() => {
            handleCloseMenu();
          }}
        >
          <div className="collapse_menu"></div>
          <div className="collapse_div"></div>
        </div>
        <div className="Content__menu-navigator">
          <InfoTechnologyProcess />
          <OfficeProcess />
          <HumanOrganizationDepartment />
          <ApplicationForLeaveNBA />
          <ApplicationForLeaveDAD />
          {/* <PlanningDepartment /> */}
          {/* <ResourcesDepartmentProcess />
          <SafeDepartment /> */}
          {/* <ProcedureAccountingDept /> */}
          {/* <TrainingMenu /> */}
        </div>
      </div>

      <div className={closeMenu ? "Main__Content-hide" : "Main__Content"}>
        <div className="px-3 pt-2">
          <CountPreview />
        </div>
        <Component {...props} />
      </div>
    </>
  );
};

export const withLandingProcedureWraper = (Component: any) => (props: any) => {
  const breakpoint = useMediaQuery("(max-width: 1080px)");
  const [closeMenu, setCloseMenu] = useState(breakpoint);

  const handleCloseMenu = () => {
    setCloseMenu(!closeMenu);
  };

  useEffect(() => {
    if (breakpoint) {
      return;
    }

    let timer: NodeJS.Timeout | null = null;

    if (!closeMenu) {
      timer = setTimeout(() => {
        setCloseMenu(true);
      }, 30000);
    }

    return () => {
      timer && clearTimeout(timer);
    };
  }, [breakpoint, closeMenu]);

  return (
    <>
      <Header />
      <div className={closeMenu === false ? "Menu__Navgiator" : "Menu__Navgiator active"}>
        <div
          className="collapse_icons"
          onClick={() => {
            handleCloseMenu();
          }}
        >
          <div className="collapse_menu"></div>
          <div className="collapse_div"></div>
        </div>
        <div className="Content__menu-navigator">
          <ViagsChat />
          <EOfficeProcess />
          <ViagsDocument />
        </div>
        {/* <TrainingMenu /> */}
      </div>

      <div className={closeMenu ? "Main__Content-hide" : "Main__Content"}>
        <Component {...props} />
      </div>
    </>
  );
};

export const useMediaQuery = (query: string, skip: boolean = false) => {
  const [matches, setMatches] = useState<boolean>(window.matchMedia(query).matches);

  useEffect(() => {
    if (skip) {
      return;
    }

    const media = window.matchMedia(query);

    const handleChange = () => {
      setMatches(media.matches);
    };

    media.addEventListener("change", handleChange);

    /**
     * Init value
     */
    handleChange();

    return () => {
      media.removeEventListener("change", handleChange);
    };
  }, [query, skip]);

  return matches;
};
